// project import
import Loadable from "../components/Loadable";
import MainLayout from "../layout/MainLayout";
import MinimalLayout from "../layout/MinimalLayout";
import { lazy } from "react";
import { Navigate } from "react-router-dom";
import AnnotationEditor from "../pages/AnnotationEditor/AnnotationEditor";
import KeymessageAnnotation from "../pages/KeymessageAnnotation/KeymessageAnnotation";

// render - dashboard
const DashboardDefault = Loadable(lazy(() => import("../pages/dashboard")));

// render - sample page
const SamplePage = Loadable(lazy(() => import("../pages/extra-pages/SamplePage")));

// render - utilities
const Typography = Loadable(lazy(() => import("../pages/components-overview/Typography")));
const Color = Loadable(lazy(() => import("../pages/components-overview/Color")));
const Presentation = Loadable(lazy(() => import("../pages/Presentation/Presentation")));
const Template = Loadable(lazy(() => import("../pages/Template/Template")));
const TemplateEditor = lazy(() => import("../pages/TemplateEditor/TemplateEditor"));
const ComponentSetting = lazy(() => import("../pages/Component/Component.jsx"));
const Emailer = lazy(() => import("../pages/Emailer/Emailer"));
const Imports = lazy(() => import("../pages/Imports/Imports"));
const ImportKMs = lazy(() => import("../pages/ImportKMs/ImportKMs"));
const CodeEditor = lazy(() => import("../pages/CodeEditor/CodeEditor"));
const ImportEditor = lazy(() => import("../pages/ImportEditor/ImportEditor"));
const Comparison = lazy(() => import("../pages/Comparison/Comparison"));
const Suggestion = lazy(() => import("../pages/Suggestion/Suggestion"));
const Settings = lazy(() => import("../pages/Settings/Settings"));
const DspReport = lazy(() => import("../pages/DspReport/DspReport"));
const NextPresentation = lazy(() => import("../pages/NextPresentation/NextPresentation"));
const NextKeyMessage = lazy(() => import("../pages/NextKeyMessage/NextKeyMessage.jsx"));
const MigrationContent = lazy(() => import("../pages/MigrationContent/MigrationContent.jsx"));

const Component = lazy(() => import("../pages/Component/Component"));
const ComponentEditor = lazy(() => import("../pages/ComponentEditor/ComponentEditor.jsx"));

const KeyMessage = lazy(() => import("../pages/KeyMessage/KeyMessage"));
const Editor = lazy(() => import("../pages/Editor/Editor"));
const NextEditor = lazy(() => import("../pages/NextEditor/NextEditor.jsx"));

const EmailerEditor = lazy(() => import("../pages/EmailerEditor/EmailerEditor"));
const Signup = lazy(() => import("../pages/Signup/Signup"));
const Login = lazy(() => import("../pages/Login/Login"));
const ForgotPassword = lazy(() => import("../pages/ForgotPassword/ForgotPassword"));
const EmailVerifier = lazy(() => import("../pages/EmailVerifier/EmailVerifier"));

// const PdfCompare = lazy(() => import("../pages/PdfCompare/PdfCompare"));
const AntIcons = Loadable(lazy(() => import("../pages/components-overview/AntIcons")));

// ==============================|| MAIN ROUTING ||============================== //
let isAuthenticated = localStorage.getItem("name");
// alert(isAuthenticated !== null && isAuthenticated !== undefined)
const MainRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [
    {
      path: "/",
      element: <DashboardDefault />,
    },
    {
      path: "/templates",
      element: <Template />,
    },
    {
      path: "/presentations",
      element: <Presentation />,
    },
    {
      path: "/components",
      element: <Component />,
    },
    {
      path: "/imports",
      element: <Imports />,
    },
    {
      path: "/suggestions",
      element: <Suggestion />,
    },
    {
      path: "/settings",
      element: <Settings />,
    },
    {
      path: "/presentations/:id/key-messages",
      element: <KeyMessage />,
    },
    {
      path: "/imports/:id/key-messages",
      element: <ImportKMs />,
    },
    {
      path: "/imports/:pId/km/:kmId/code",
      element: <CodeEditor />,
    },
    {
      path: "/comparison/:pId",
      element: <Comparison />,
    },
    {
      path: "/emailer",
      element: <Emailer />,
    },
    {
      path: "/dspreport",
      element: <DspReport />,
    },
    {
      path: "/next-presentations",
      element: <NextPresentation />,
    },
    {
      path: "/next-presentations/:id/key-messages",
      element: <NextKeyMessage />,
    },
    {
      path: "/migration-contents",
      element: <MigrationContent />,
    },
    {
      path: "/presentations/:presentationId/key-messages/:kmId/annotations",
      element: <KeymessageAnnotation />,
    },
    {
      path: "/*",
      element: (
        <Navigate
          to="/"
          replace
        />
      ),
    },
  ],
};

const EditorRoutes = {
  path: "/",
  element: <MinimalLayout />,
  children: [
    {
      path: "/presentations/:presentationId/key-messages/:kmId/edit",
      element: <Editor />,
    },
    // {
    //   path: "/presentations/:presentationId/key-messages/:kmId/annotations",
    //   element: <AnnotationEditor />,
    // },
    {
      path: "/templates/:templateId/edit",
      element: <TemplateEditor />,
    },
    {
      path: "/components/:rcId/edit",
      element: <ComponentEditor />,
    },
    {
      path: "/imports/:pId/key-messages/:kmId/edit",
      element: <ImportEditor />,
    },
    {
      path: "/emailer/:emailerId/edit",
      element: <EmailerEditor />,
    },
    {
      path: "/next-presentations/:presentationId/key-messages/:kmId/edit",
      element: <NextEditor />,
    },
    {
      path: "/comparisons/:presentationId",
      element: <Comparison />,
    },
    {
      path: "/components",
      element: <ComponentSetting />,
    },
  ],
};

const AuthRoutes = {
  element: <MinimalLayout />,
  children: [
    {
      path: "/user/login",
      element: <Login />,
    },
    {
      path: "/user/signup",
      element: <Signup />,
    },
    {
      path: "/user/auth/:token",
      element: <EmailVerifier />,
    },
    {
      path: "/user/reset-password",
      element: <ForgotPassword />,
    },
    {
      path: "/user/reset-password/:token",
      element: <ForgotPassword />,
    },

    {
      path: "/*",
      element: (
        <Navigate
          to="/user/login"
          replace
        />
      ),
    },
  ],
};
export { MainRoutes, AuthRoutes, EditorRoutes };
